module.exports = __webpack_public_path__ + "22a9b4ad959eea98de9a021f80d4019f.pdf";